var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedBusinessCardTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31787 12.7682C2.31787 8.49291 2.31787 6.35528 3.7936 5.02712C5.26933 3.69896 7.64449 3.69896 12.3948 3.69896C17.1451 3.69896 19.5203 3.69896 20.996 5.02712C22.4717 6.35528 22.4717 8.49291 22.4717 12.7682C22.4717 17.0435 22.4717 19.1811 20.996 20.5093C19.5203 21.8374 17.1451 21.8374 12.3948 21.8374C7.64449 21.8374 5.26933 21.8374 3.7936 20.5093C2.31787 19.1811 2.31787 17.0435 2.31787 12.7682Z",
    fill: "#FC374E",
    stroke: "white",
    strokeWidth: 1.51154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76709 8.73744H7.96094C7.20089 8.73744 6.82087 8.73744 6.58475 8.97356C6.34863 9.20968 6.34863 9.5897 6.34863 10.3497V11.1559C6.34863 11.916 6.34863 12.296 6.58475 12.5321C6.82087 12.7682 7.20089 12.7682 7.96094 12.7682H8.76709C9.52714 12.7682 9.90717 12.7682 10.1433 12.5321C10.3794 12.296 10.3794 11.916 10.3794 11.1559V10.3497C10.3794 9.5897 10.3794 9.20968 10.1433 8.97356C9.90717 8.73744 9.52714 8.73744 8.76709 8.73744Z",
    stroke: "white",
    strokeWidth: 1.51154,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34863 16.799H10.3794",
    stroke: "white",
    strokeWidth: 1.51154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4102 8.73744H18.4409",
    stroke: "white",
    strokeWidth: 1.51154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4102 12.7682H18.4409",
    stroke: "white",
    strokeWidth: 1.51154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4102 16.799H18.4409",
    stroke: "white",
    strokeWidth: 1.51154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBusinessCardTab);
export default __webpack_public_path__ + "static/media/selectedBusinessCardTab.439f1577b619596866ee7b0dcdd4b9eb.svg";
export { ForwardRef as ReactComponent };